module.exports = __webpack_public_path__ + "static/media/icon-value.dbd7d763.svg";